import type { RoomService } from './ports/RoomService';
import { LiveKitRoomService } from './adapters/LiveKitRoomService';
import { getMeetingSocket as getSharedMeetingSocket } from '../backend-api';
import type { MeetingSocketPort } from '../backend-api';

let roomServiceInstance: RoomService | null = null;

/**
 * Returns the singleton RoomService. Swap LiveKitRoomService for
 * RustBackendRoomService here when the Rust server is ready — no other
 * file needs to change.
 */
export function getRoomService(): RoomService {
  if (!roomServiceInstance) {
    roomServiceInstance = new LiveKitRoomService();
  }
  return roomServiceInstance;
}

/**
 * Returns the singleton meeting event socket (GET /meetings/{id}/ws).
 */
export function getMeetingSocket(): MeetingSocketPort {
  return getSharedMeetingSocket();
}

export function __resetRoomContainer(): void {
  roomServiceInstance = null;
}